const getDefaultWindow = () => (typeof window !== 'undefined' ? window : null);

const getBrowserStorage = (storageName, windowObject = getDefaultWindow()) => {
  try {
    return windowObject?.[storageName] || null;
  } catch (_) {
    return null;
  }
};

const getLocalStorage = (windowObject = getDefaultWindow()) =>
  getBrowserStorage('localStorage', windowObject);

const getSessionStorage = (windowObject = getDefaultWindow()) =>
  getBrowserStorage('sessionStorage', windowObject);

const safeGetStorageItem = (storage, key, fallback = null) => {
  try {
    const value = storage?.getItem?.(key);

    return value === null || value === undefined ? fallback : value;
  } catch (_) {
    return fallback;
  }
};

const safeSetStorageItem = (storage, key, value) => {
  try {
    if (!storage?.setItem) return false;

    storage.setItem(key, value);
    return true;
  } catch (_) {
    return false;
  }
};

const safeRemoveStorageItem = (storage, key) => {
  try {
    if (!storage?.removeItem) return false;

    storage.removeItem(key);
    return true;
  } catch (_) {
    return false;
  }
};

const safeClearStorage = (storage) => {
  try {
    if (!storage?.clear) return false;

    storage.clear();
    return true;
  } catch (_) {
    return false;
  }
};

const safeGetJsonStorageItem = (storage, key, fallback = null) => {
  const value = safeGetStorageItem(storage, key);

  if (value === null || value === undefined) {
    return fallback;
  }

  try {
    return JSON.parse(value);
  } catch (_) {
    return fallback;
  }
};

export {
  getBrowserStorage,
  getLocalStorage,
  getSessionStorage,
  safeClearStorage,
  safeGetJsonStorageItem,
  safeGetStorageItem,
  safeRemoveStorageItem,
  safeSetStorageItem,
};
